import { AccessType, AccessTypeOptions } from '@common';
import { MPAlert, MPPassword, MPSwitch } from '@components';
import { Col, Collapse, Form, Radio, Row } from 'antd';
import ConditionallyRender from 'react-conditionally-render';
import PermissionsTable from './PermissionsTable';
import SharingTable from './SharingTable';
import Styles from './Styles.module.scss';

export default function AccessManagement() {
    const accessType = Form.useWatch(['accessManagement', 'access']);
    const passwordRequired = Form.useWatch(['accessManagement', 'passwordRequired']);

    return (
        <>
            <Row gutter={24}>
                <Col span={12}>
                    <Form.Item
                        name={['accessManagement', 'access']}
                        label={'Access'}
                        initialValue={'public'}
                    >
                        <Radio.Group options={AccessTypeOptions} />
                    </Form.Item>
                </Col>

                <ConditionallyRender
                    condition={accessType !== AccessType.PUBLIC}
                    show={
                        <Row gutter={24}>
                            <Col span={8}>
                                <Form.Item
                                    name={['accessManagement', 'password']}
                                    label={'Password'}
                                    rules={[{ required: passwordRequired, message: 'Please input your password!' }]}
                                >
                                    <MPPassword />
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item
                                    name={['accessManagement', 'passwordRequired']}
                                    label={'Password Required'}
                                    valuePropName="checked"
                                >
                                    <MPSwitch />
                                </Form.Item>
                            </Col>
                        </Row>
                    }
                />
                <Col>
                    <Form.Item
                        name={'hideMyName'}
                        label={'Hide My Name'}
                        valuePropName="checked"
                        initialValue={false}
                        help={'If checked, your name will not be displayed'}
                    >
                        <MPSwitch />
                    </Form.Item>
                </Col>
            </Row>

            <Collapse
                className={Styles.Permissions}
                defaultActiveKey={['sharing']}
                items={[
                    {
                        key: 'permissions',
                        label: (
                            <div className="flex items-center gap-2">
                                Permissions
                                <MPAlert
                                    message="You can add users to your project by entering their email address."
                                    type="info"
                                    closable
                                />
                            </div>
                        ),
                        children: <PermissionsTable />,
                    },
                    {
                        key: 'sharing',
                        label: (
                            <div className="flex items-center gap-2">
                                Sharing
                                <MPAlert
                                    message="You can share your project with others by passing a password."
                                    type="info"
                                    closable
                                />
                            </div>
                        ),
                        children: (
                            <Form.Item name={['accessManagement', 'sharing']}>
                                <SharingTable />
                            </Form.Item>
                        ),
                    },
                ]}
            />
        </>
    );
}
